export const REGISTRATION_PATH = "/api/users/phone-sign-up";
export const SET_PINCODE_PATH = "api/users/:id/pin-code";
export const PROFILE_URL = "/api/profiles";
export const USERS_URL = "/api/users";
export const ADDRESS_URL = "api/addresses";
export const LIST_PROFILES_URL = "/api/profiles";
export const ACTION_DEACTIVE_AND_ACTIVE = (id) =>
  `/api/users/${id}/activate-deactivate`;
